import { ReactNode } from 'react'
import { Navigation } from './Navigation'
import { Footer } from './Footer'

interface PageLayoutProps {
  children: ReactNode
  className?: string
  showNavigation?: boolean
  showFooter?: boolean
}

export function PageLayout({ 
  children, 
  className = '', 
  showNavigation = true, 
  showFooter = true 
}: PageLayoutProps) {
  return (
    <div className={`min-h-screen bg-background text-foreground ${className}`}>
      {showNavigation && <Navigation />}
      
      <main className="relative" style={{ paddingTop: showNavigation ? '5rem' : '0' }}>
        {children}
      </main>
      
      {showFooter && <Footer />}
    </div>
  )
}
